import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/safiruni/front/components/Articles/DescriptionSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/safiruni/front/components/Articles/TopSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/safiruni/front/components/Home/ScrollToTop .tsx");
;
import(/* webpackMode: "eager" */ "/var/www/safiruni/front/public/images/bgLinear.png");
